import { render, staticRenderFns } from "./DocumentPickerV1.vue?vue&type=template&id=b8bd5408&"
import script from "./DocumentPickerV1.vue?vue&type=script&lang=js&"
export * from "./DocumentPickerV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports